/* adpbtds-bmsm.js — All JS for the BMSM section — v2 */

(function() {
  var sectionEl = document.querySelector('.hdt-buy-more-save-more-section');
  if (!sectionEl) return;

  var sectionId = sectionEl.dataset.sectionId;
  var variantsScript = document.getElementById('bmsm-product-variants-' + sectionId);
  if (!variantsScript) return;
  var variantsData = JSON.parse(variantsScript.textContent);

  /* ── Hardcoded variant IDs (all 360 — bypasses Liquid's 250 cap) ── */
  var variantMap = {
'32A|Beige|1 Pack':53442847047994,'32A|Beige|2 Packs':53442847080762,'32A|Beige|3 Packs':53442847113530,
'32A|Onyx|1 Pack':53442847146298,'32A|Onyx|2 Packs':53442847179066,'32A|Onyx|3 Packs':53442847211834,
'32A|Caramel|1 Pack':53442847244602,'32A|Caramel|2 Packs':53442847277370,'32A|Caramel|3 Packs':53442847310138,
'32A|Ivory|1 Pack':53442847342906,'32A|Ivory|2 Packs':53442847375674,'32A|Ivory|3 Packs':53442847408442,
'32A|Cocoa|1 Pack':53442847441210,'32A|Cocoa|2 Packs':53442847473978,'32A|Cocoa|3 Packs':53442847506746,
'32B|Beige|1 Pack':53442847539514,'32B|Beige|2 Packs':53442847572282,'32B|Beige|3 Packs':53442847605050,
'32B|Onyx|1 Pack':53442847637818,'32B|Onyx|2 Packs':53442847670586,'32B|Onyx|3 Packs':53442847703354,
'32B|Caramel|1 Pack':53442847736122,'32B|Caramel|2 Packs':53442847768890,'32B|Caramel|3 Packs':53442847801658,
'32B|Ivory|1 Pack':53442847834426,'32B|Ivory|2 Packs':53442847867194,'32B|Ivory|3 Packs':53442847899962,
'32B|Cocoa|1 Pack':53442847932730,'32B|Cocoa|2 Packs':53442847965498,'32B|Cocoa|3 Packs':53442847998266,
'32C|Beige|1 Pack':53442848031034,'32C|Beige|2 Packs':53442848063802,'32C|Beige|3 Packs':53442848096570,
'32C|Onyx|1 Pack':53442848129338,'32C|Onyx|2 Packs':53442848162106,'32C|Onyx|3 Packs':53442848194874,
'32C|Caramel|1 Pack':53442848227642,'32C|Caramel|2 Packs':53442848260410,'32C|Caramel|3 Packs':53442848293178,
'32C|Ivory|1 Pack':53442848325946,'32C|Ivory|2 Packs':53442848358714,'32C|Ivory|3 Packs':53442848391482,
'32C|Cocoa|1 Pack':53442848424250,'32C|Cocoa|2 Packs':53442848457018,'32C|Cocoa|3 Packs':53442848489786,
'32D|Beige|1 Pack':53442848522554,'32D|Beige|2 Packs':53442848555322,'32D|Beige|3 Packs':53442848588090,
'32D|Onyx|1 Pack':53442848620858,'32D|Onyx|2 Packs':53442848653626,'32D|Onyx|3 Packs':53442848686394,
'32D|Caramel|1 Pack':53442848719162,'32D|Caramel|2 Packs':53442848751930,'32D|Caramel|3 Packs':53442848784698,
'32D|Ivory|1 Pack':53442848817466,'32D|Ivory|2 Packs':53442848850234,'32D|Ivory|3 Packs':53442848883002,
'32D|Cocoa|1 Pack':53442848915770,'32D|Cocoa|2 Packs':53442848948538,'32D|Cocoa|3 Packs':53442848981306,
'32E|Beige|1 Pack':53442849014074,'32E|Beige|2 Packs':53442849046842,'32E|Beige|3 Packs':53442849079610,
'32E|Onyx|1 Pack':53442849112378,'32E|Onyx|2 Packs':53442849145146,'32E|Onyx|3 Packs':53442849177914,
'32E|Caramel|1 Pack':53442849210682,'32E|Caramel|2 Packs':53442849243450,'32E|Caramel|3 Packs':53442849276218,
'32E|Ivory|1 Pack':53442849308986,'32E|Ivory|2 Packs':53442849341754,'32E|Ivory|3 Packs':53442849374522,
'32E|Cocoa|1 Pack':53442849407290,'32E|Cocoa|2 Packs':53442849440058,'32E|Cocoa|3 Packs':53442849472826,
'32F|Beige|1 Pack':53442849505594,'32F|Beige|2 Packs':53442849538362,'32F|Beige|3 Packs':53442849571130,
'32F|Onyx|1 Pack':53442849603898,'32F|Onyx|2 Packs':53442849636666,'32F|Onyx|3 Packs':53442849669434,
'32F|Caramel|1 Pack':53442849702202,'32F|Caramel|2 Packs':53442849734970,'32F|Caramel|3 Packs':53442849767738,
'32F|Ivory|1 Pack':53442849800506,'32F|Ivory|2 Packs':53442849833274,'32F|Ivory|3 Packs':53442849866042,
'32F|Cocoa|1 Pack':53442849898810,'32F|Cocoa|2 Packs':53442849931578,'32F|Cocoa|3 Packs':53442849964346,
'34A|Beige|1 Pack':53442849997114,'34A|Beige|2 Packs':53442850029882,'34A|Beige|3 Packs':53442850062650,
'34A|Onyx|1 Pack':53442850095418,'34A|Onyx|2 Packs':53442850128186,'34A|Onyx|3 Packs':53442850160954,
'34A|Caramel|1 Pack':53442850193722,'34A|Caramel|2 Packs':53442850226490,'34A|Caramel|3 Packs':53442850259258,
'34A|Ivory|1 Pack':53442850292026,'34A|Ivory|2 Packs':53442850324794,'34A|Ivory|3 Packs':53442850357562,
'34A|Cocoa|1 Pack':53442850390330,'34A|Cocoa|2 Packs':53442850423098,'34A|Cocoa|3 Packs':53442850455866,
'34B|Beige|1 Pack':53442850488634,'34B|Beige|2 Packs':53442850521402,'34B|Beige|3 Packs':53442850554170,
'34B|Onyx|1 Pack':53442850586938,'34B|Onyx|2 Packs':53442850619706,'34B|Onyx|3 Packs':53442850652474,
'34B|Caramel|1 Pack':53442850685242,'34B|Caramel|2 Packs':53442850718010,'34B|Caramel|3 Packs':53442850750778,
'34B|Ivory|1 Pack':53442850783546,'34B|Ivory|2 Packs':53442850816314,'34B|Ivory|3 Packs':53442850849082,
'34B|Cocoa|1 Pack':53442850881850,'34B|Cocoa|2 Packs':53442850914618,'34B|Cocoa|3 Packs':53442850947386,
'34C|Beige|1 Pack':53442850980154,'34C|Beige|2 Packs':53442851012922,'34C|Beige|3 Packs':53442851045690,
'34C|Onyx|1 Pack':53442851078458,'34C|Onyx|2 Packs':53442851111226,'34C|Onyx|3 Packs':53442851143994,
'34C|Caramel|1 Pack':53442851176762,'34C|Caramel|2 Packs':53442851209530,'34C|Caramel|3 Packs':53442851242298,
'34C|Ivory|1 Pack':53442851275066,'34C|Ivory|2 Packs':53442851307834,'34C|Ivory|3 Packs':53442851340602,
'34C|Cocoa|1 Pack':53442851373370,'34C|Cocoa|2 Packs':53442851406138,'34C|Cocoa|3 Packs':53442851438906,
'34D|Beige|1 Pack':53442851471674,'34D|Beige|2 Packs':53442851504442,'34D|Beige|3 Packs':53442851537210,
'34D|Onyx|1 Pack':53442851569978,'34D|Onyx|2 Packs':53442851602746,'34D|Onyx|3 Packs':53442851635514,
'34D|Caramel|1 Pack':53442851668282,'34D|Caramel|2 Packs':53442851701050,'34D|Caramel|3 Packs':53442851733818,
'34D|Ivory|1 Pack':53442851766586,'34D|Ivory|2 Packs':53442851799354,'34D|Ivory|3 Packs':53442851832122,
'34D|Cocoa|1 Pack':53442851864890,'34D|Cocoa|2 Packs':53442851897658,'34D|Cocoa|3 Packs':53442851930426,
'34E|Beige|1 Pack':53442851963194,'34E|Beige|2 Packs':53442851995962,'34E|Beige|3 Packs':53442852028730,
'34E|Onyx|1 Pack':53442852061498,'34E|Onyx|2 Packs':53442852094266,'34E|Onyx|3 Packs':53442852127034,
'34E|Caramel|1 Pack':53442852159802,'34E|Caramel|2 Packs':53442852192570,'34E|Caramel|3 Packs':53442852225338,
'34E|Ivory|1 Pack':53442852258106,'34E|Ivory|2 Packs':53442852290874,'34E|Ivory|3 Packs':53442852323642,
'34E|Cocoa|1 Pack':53442852356410,'34E|Cocoa|2 Packs':53442852389178,'34E|Cocoa|3 Packs':53442852421946,
'34F|Beige|1 Pack':53442852454714,'34F|Beige|2 Packs':53442852487482,'34F|Beige|3 Packs':53442852520250,
'34F|Onyx|1 Pack':53442852553018,'34F|Onyx|2 Packs':53442852585786,'34F|Onyx|3 Packs':53442852618554,
'34F|Caramel|1 Pack':53442852651322,'34F|Caramel|2 Packs':53442852684090,'34F|Caramel|3 Packs':53442852716858,
'34F|Ivory|1 Pack':53442852749626,'34F|Ivory|2 Packs':53442852782394,'34F|Ivory|3 Packs':53442852815162,
'34F|Cocoa|1 Pack':53442852847930,'34F|Cocoa|2 Packs':53442852880698,'34F|Cocoa|3 Packs':53442852913466,
'36A|Beige|1 Pack':53442852946234,'36A|Beige|2 Packs':53442852979002,'36A|Beige|3 Packs':53442853011770,
'36A|Onyx|1 Pack':53442853044538,'36A|Onyx|2 Packs':53442853077306,'36A|Onyx|3 Packs':53442853110074,
'36A|Caramel|1 Pack':53442853142842,'36A|Caramel|2 Packs':53442853175610,'36A|Caramel|3 Packs':53442853208378,
'36A|Ivory|1 Pack':53442853241146,'36A|Ivory|2 Packs':53442853273914,'36A|Ivory|3 Packs':53442853306682,
'36A|Cocoa|1 Pack':53442853339450,'36A|Cocoa|2 Packs':53442853372218,'36A|Cocoa|3 Packs':53442853404986,
'36B|Beige|1 Pack':53442853437754,'36B|Beige|2 Packs':53442853470522,'36B|Beige|3 Packs':53442853503290,
'36B|Onyx|1 Pack':53442853536058,'36B|Onyx|2 Packs':53442853568826,'36B|Onyx|3 Packs':53442853601594,
'36B|Caramel|1 Pack':53442853634362,'36B|Caramel|2 Packs':53442853667130,'36B|Caramel|3 Packs':53442853699898,
'36B|Ivory|1 Pack':53442853732666,'36B|Ivory|2 Packs':53442853765434,'36B|Ivory|3 Packs':53442853798202,
'36B|Cocoa|1 Pack':53442853830970,'36B|Cocoa|2 Packs':53442853863738,'36B|Cocoa|3 Packs':53442853896506,
'36C|Beige|1 Pack':53442853929274,'36C|Beige|2 Packs':53442853962042,'36C|Beige|3 Packs':53442853994810,
'36C|Onyx|1 Pack':53442854027578,'36C|Onyx|2 Packs':53442854060346,'36C|Onyx|3 Packs':53442854093114,
'36C|Caramel|1 Pack':53442854125882,'36C|Caramel|2 Packs':53442854158650,'36C|Caramel|3 Packs':53442854191418,
'36C|Ivory|1 Pack':53442854224186,'36C|Ivory|2 Packs':53442854256954,'36C|Ivory|3 Packs':53442854289722,
'36C|Cocoa|1 Pack':53442854322490,'36C|Cocoa|2 Packs':53442854355258,'36C|Cocoa|3 Packs':53442854388026,
'36D|Beige|1 Pack':53442854420794,'36D|Beige|2 Packs':53442854453562,'36D|Beige|3 Packs':53442854486330,
'36D|Onyx|1 Pack':53442854519098,'36D|Onyx|2 Packs':53442854551866,'36D|Onyx|3 Packs':53442854584634,
'36D|Caramel|1 Pack':53442854617402,'36D|Caramel|2 Packs':53442854650170,'36D|Caramel|3 Packs':53442854682938,
'36D|Ivory|1 Pack':53442854715706,'36D|Ivory|2 Packs':53442854748474,'36D|Ivory|3 Packs':53442854781242,
'36D|Cocoa|1 Pack':53442854814010,'36D|Cocoa|2 Packs':53442854846778,'36D|Cocoa|3 Packs':53442854879546,
'36E|Beige|1 Pack':53442854912314,'36E|Beige|2 Packs':53442854945082,'36E|Beige|3 Packs':53442854977850,
'36E|Onyx|1 Pack':53442855010618,'36E|Onyx|2 Packs':53442855043386,'36E|Onyx|3 Packs':53442855076154,
'36E|Caramel|1 Pack':53442855108922,'36E|Caramel|2 Packs':53442855141690,'36E|Caramel|3 Packs':53442855174458,
'36E|Ivory|1 Pack':53442855207226,'36E|Ivory|2 Packs':53442855239994,'36E|Ivory|3 Packs':53442855272762,
'36E|Cocoa|1 Pack':53442855305530,'36E|Cocoa|2 Packs':53442855338298,'36E|Cocoa|3 Packs':53442855371066,
'38A|Beige|1 Pack':53442855403834,'38A|Beige|2 Packs':53442855436602,'38A|Beige|3 Packs':53442855469370,
'38A|Onyx|1 Pack':53442855502138,'38A|Onyx|2 Packs':53442855534906,'38A|Onyx|3 Packs':53442855567674,
'38A|Caramel|1 Pack':53442855600442,'38A|Caramel|2 Packs':53442855633210,'38A|Caramel|3 Packs':53442855665978,
'38A|Ivory|1 Pack':53442855698746,'38A|Ivory|2 Packs':53442855731514,'38A|Ivory|3 Packs':53442855764282,
'38A|Cocoa|1 Pack':53442855797050,'38A|Cocoa|2 Packs':53442855829818,'38A|Cocoa|3 Packs':53442855862586,
'38B|Beige|1 Pack':53442855895354,'38B|Beige|2 Packs':53442855928122,'38B|Beige|3 Packs':53442855960890,
'38B|Onyx|1 Pack':53442855993658,'38B|Onyx|2 Packs':53442856026426,'38B|Onyx|3 Packs':53442856059194,
'38B|Caramel|1 Pack':53442856091962,'38B|Caramel|2 Packs':53442856124730,'38B|Caramel|3 Packs':53442856157498,
'38B|Ivory|1 Pack':53442856190266,'38B|Ivory|2 Packs':53442856223034,'38B|Ivory|3 Packs':53442856255802,
'38B|Cocoa|1 Pack':53442856288570,'38B|Cocoa|2 Packs':53442856321338,'38B|Cocoa|3 Packs':53442856354106,
'38C|Beige|1 Pack':53442856386874,'38C|Beige|2 Packs':53442856419642,'38C|Beige|3 Packs':53442856452410,
'38C|Onyx|1 Pack':53442856485178,'38C|Onyx|2 Packs':53442856517946,'38C|Onyx|3 Packs':53442856550714,
'38C|Caramel|1 Pack':53442856583482,'38C|Caramel|2 Packs':53442856616250,'38C|Caramel|3 Packs':53442856649018,
'38C|Ivory|1 Pack':53442856681786,'38C|Ivory|2 Packs':53442856714554,'38C|Ivory|3 Packs':53442856747322,
'38C|Cocoa|1 Pack':53442856780090,'38C|Cocoa|2 Packs':53442856812858,'38C|Cocoa|3 Packs':53442856845626,
'38D|Beige|1 Pack':53442856878394,'38D|Beige|2 Packs':53442856911162,'38D|Beige|3 Packs':53442856943930,
'38D|Onyx|1 Pack':53442856976698,'38D|Onyx|2 Packs':53442857009466,'38D|Onyx|3 Packs':53442857042234,
'38D|Caramel|1 Pack':53442857075002,'38D|Caramel|2 Packs':53442857107770,'38D|Caramel|3 Packs':53442857140538,
'38D|Ivory|1 Pack':53442857173306,'38D|Ivory|2 Packs':53442857206074,'38D|Ivory|3 Packs':53442857238842,
'38D|Cocoa|1 Pack':53442857271610,'38D|Cocoa|2 Packs':53442857304378,'38D|Cocoa|3 Packs':53442857337146,
'40A|Beige|1 Pack':53442857369914,'40A|Beige|2 Packs':53442857402682,'40A|Beige|3 Packs':53442857435450,
'40A|Onyx|1 Pack':53442857468218,'40A|Onyx|2 Packs':53442857500986,'40A|Onyx|3 Packs':53442857533754,
'40A|Caramel|1 Pack':53442857566522,'40A|Caramel|2 Packs':53442857599290,'40A|Caramel|3 Packs':53442857632058,
'40A|Ivory|1 Pack':53442857664826,'40A|Ivory|2 Packs':53442857697594,'40A|Ivory|3 Packs':53442857730362,
'40A|Cocoa|1 Pack':53442857763130,'40A|Cocoa|2 Packs':53442857795898,'40A|Cocoa|3 Packs':53442857828666,
'40B|Beige|1 Pack':53442857861434,'40B|Beige|2 Packs':53442857894202,'40B|Beige|3 Packs':53442857926970,
'40B|Onyx|1 Pack':53442857959738,'40B|Onyx|2 Packs':53442857992506,'40B|Onyx|3 Packs':53442858025274,
'40B|Caramel|1 Pack':53442858058042,'40B|Caramel|2 Packs':53442858090810,'40B|Caramel|3 Packs':53442858123578,
'40B|Ivory|1 Pack':53442858156346,'40B|Ivory|2 Packs':53442858189114,'40B|Ivory|3 Packs':53442858221882,
'40B|Cocoa|1 Pack':53442858254650,'40B|Cocoa|2 Packs':53442858287418,'40B|Cocoa|3 Packs':53442858320186,
'40C|Beige|1 Pack':53442858352954,'40C|Beige|2 Packs':53442858385722,'40C|Beige|3 Packs':53442858418490,
'40C|Onyx|1 Pack':53442858451258,'40C|Onyx|2 Packs':53442858484026,'40C|Onyx|3 Packs':53442858516794,
'40C|Caramel|1 Pack':53442858549562,'40C|Caramel|2 Packs':53442858582330,'40C|Caramel|3 Packs':53442858615098,
'40C|Ivory|1 Pack':53442858647866,'40C|Ivory|2 Packs':53442858680634,'40C|Ivory|3 Packs':53442858713402,
'40C|Cocoa|1 Pack':53442858746170,'40C|Cocoa|2 Packs':53442858778938,'40C|Cocoa|3 Packs':53442858811706
  };

  /* ── Helpers ── */
  function getSelectedColor() {
    var radio = sectionEl.querySelector('fieldset.is-style-color input[type="radio"]:checked');
    if (radio) return radio.value;
    var label = sectionEl.querySelector('fieldset.is-style-color [update-value]');
    return label ? label.textContent.trim() : '';
  }

  /* ── 1. Checkout ── */
  var checkoutBtn = document.getElementById('bmsm-checkout-btn-' + sectionId);
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      var btn = this;
      if (btn.getAttribute('aria-busy') === 'true') return;

      var sizeInput = sectionEl.querySelector('input[is-value][name="option1"]');
      var size = sizeInput ? sizeInput.value : '';
      var color = getSelectedColor();

      var activeRow = sectionEl.querySelector('.hdt-bmsm-bundle-row.active');
      var bundleQty = activeRow ? parseInt(activeRow.getAttribute('data-qty')) : 1;
      var qtyStr = bundleQty === 1 ? '1 Pack' : bundleQty + ' Packs';

      // Check stock map first — must be in stock for this color+size
      if (!stock[color] || stock[color].indexOf(size) === -1) return;

      var key = size + '|' + color + '|' + qtyStr;
      var variantId = variantMap[key];
      if (!variantId) return;

      btn.setAttribute('aria-busy', 'true');
      btn.querySelector('.hdt-btn-atc_text').textContent = 'PROCESSING...';
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.items || data.id) {
            window.location.href = '/checkout';
          } else {
            btn.removeAttribute('aria-busy');
            btn.querySelector('.hdt-btn-atc_text').textContent = 'CHECKOUT';
          }
        })
        .catch(function() {
          btn.removeAttribute('aria-busy');
          btn.querySelector('.hdt-btn-atc_text').textContent = 'CHECKOUT';
        });
    });
  }

  /* ── 2. Dialog patch (non-modal) ── */
  function patchDialogs() {
    sectionEl.querySelectorAll('.hdt-popover-variant').forEach(function(dialog) {
      if (dialog._bmsmPatched) return;
      dialog._bmsmPatched = true;
      dialog.showModal = function() { if (!this.open) this.show(); };
    });
  }
  patchDialogs();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(patchDialogs).observe(sectionEl, { childList: true, subtree: true });
  }
  document.addEventListener('click', function(e) {
    sectionEl.querySelectorAll('.hdt-popover-variant[open]').forEach(function(dialog) {
      var popover = dialog.closest('hdt-popover');
      var trigger = popover ? popover.previousElementSibling : null;
      if (!dialog.contains(e.target) && e.target !== trigger && (!trigger || !trigger.contains(e.target))) {
        dialog.close();
      }
    });
  });

  /* ── 3. Bundle row selection ── */
  window.selectBundle = function(el, qty) {
    sectionEl.querySelectorAll('.hdt-bmsm-bundle-row').forEach(function(i) {
      i.classList.remove('active');
      var radio = i.querySelector('input[type="radio"]');
      if (radio) radio.checked = false;
    });
    el.classList.add('active');
    var activeRadio = el.querySelector('input[type="radio"]');
    if (activeRadio) activeRadio.checked = true;
    var form = sectionEl.querySelector('form');
    if (form) form.querySelector('input[name="quantity"]').value = qty;
  };

  /* ── 4. Product Switcher ── */
  sectionEl.querySelectorAll('.custom-listing-item').forEach(function(item) {
    item.addEventListener('click', function() {
      sectionEl.querySelectorAll('.custom-listing-item').forEach(function(i) { i.classList.remove('cat-active'); });
      sectionEl.querySelectorAll('.tab-content').forEach(function(c) { c.classList.remove('active'); });
      item.classList.add('cat-active');
      var targetId = item.dataset.target;
      sectionEl.querySelector('#' + targetId).classList.add('active');
    });
  });

  /* ── 5. Variant image handler ── */
  var imgScripts = sectionEl.querySelectorAll('script[id^="bmsm-variant-images-"]');
  imgScripts.forEach(function(script) {
    var variantImages = {};
    try { variantImages = JSON.parse(script.textContent); } catch(e) {}
    if (Object.keys(variantImages).length === 0) return;

    function updateImages() {
      var selectedOptions = Array.from(sectionEl.querySelectorAll('.hdt-variant-picker input[type="radio"]:checked, .hdt-variant-picker select'))
        .map(function(el) { return el.value.toLowerCase().trim(); });

      var matchedImages = null;
      for (var oi = 0; oi < selectedOptions.length; oi++) {
        if (variantImages[selectedOptions[oi]]) { matchedImages = variantImages[selectedOptions[oi]]; break; }
      }

      sectionEl.querySelectorAll('.hdt-bmsm-bundle-row').forEach(function(bundle, index) {
        var variantImg = matchedImages ? matchedImages[index] : null;
        var thumb = bundle.querySelector('.hdt-bmsm-bundle-thumb');
        if (!thumb) return;

        var defaultImgs = [null, null, null];
        try { defaultImgs = JSON.parse(bundle.dataset.defaultImages || '[]'); } catch(e) {}

        var qtyBadge = thumb.querySelector('.hdt-bmsm-bundle-qty-badge');

        if (variantImg) {
          var stack = thumb.querySelector('.hdt-bmsm-bundle-thumb-stack');
          if (stack) stack.remove();
          var imgEl = thumb.querySelector('.hdt-bmsm-bundle-img');
          if (imgEl) { imgEl.src = variantImg; imgEl.srcset = variantImg; }
          else {
            var newImg = document.createElement('img');
            newImg.className = 'hdt-bmsm-bundle-img';
            newImg.src = variantImg;
            if (qtyBadge) thumb.insertBefore(newImg, qtyBadge); else thumb.appendChild(newImg);
          }
          thumb.style.display = '';
        } else {
          var validDefaults = defaultImgs.filter(function(d) { return d !== null; });
          if (validDefaults.length >= 1) {
            var imgEl2 = thumb.querySelector('.hdt-bmsm-bundle-img');
            if (imgEl2) { imgEl2.src = validDefaults[0]; imgEl2.srcset = validDefaults[0]; }
            else {
              var newImg2 = document.createElement('img');
              newImg2.className = 'hdt-bmsm-bundle-img';
              newImg2.src = validDefaults[0];
              if (qtyBadge) thumb.insertBefore(newImg2, qtyBadge); else thumb.appendChild(newImg2);
            }
            thumb.style.display = '';
          }
        }
      });
    }

    sectionEl.addEventListener('change', function(e) {
      if (e.target.closest('hdt-variant-picker')) updateImages();
    });
    setTimeout(updateImages, 100);
  });

  /* ── 6. Size label update ── */
  var sizeEquivalents = {
    'AA':'28A, 30A, 32A, 28B, 30B, 28C','A':'34A, 32B, 30C, 28D','B':'36A, 34B, 32C, 30D, 28DD/E',
    'C':'38A, 36B, 34C, 32D, 30DD/E, 28DDD/F','D':'40A, 38B, 36C, 34D, 32DD/E, 30DDD/F, 28G',
    'E':'42A, 40B, 38C, 36D, 34DD/E, 32DDD/F, 30G, 28H','F':'44A, 42B, 40C, 38D, 36DD/E, 34DDD/F, 32G, 30H, 28I',
    'G':'44B, 42C, 40D, 38DD/E, 36DDD/F, 34G, 32H, 30I, 28J','H':'44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
    'I':'44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L','J':'44DD/E, 42DDD/F, 40G, 38H, 36I, 34J, 32K, 30L, 28M',
    'K':'44DDD/F, 42G, 40H, 38I, 36J, 34K, 32L, 30M, 28N','L':'44G, 42H, 40I, 38J, 36K, 34L, 32M, 30N, 28O',
    'M':'44H, 42I, 40J, 38K, 36L, 34M, 32N, 30O, 28P','N':'44I, 42J, 40K, 38L, 36M, 34N, 32O, 30P, 28Q',
    'O':'42K, 40L, 38M, 36N, 34O, 32P, 30Q, 28R','P':'42L, 40M, 38N, 36O, 34P, 32Q, 30R',
    'Q':'42M, 40N, 38O, 36P, 34Q, 32R, 30S','R':'44M, 42N, 40O, 38P, 36Q, 34R, 32S, 30T, 28U',
    'A/B':'34A, 32B, 30C, 28D','C/D':'38A, 36B, 34C, 32D, 30DD/E',
    'DD/E/F':'44A, 42B, 40C, 38D, 36DD/E, 34DDD/F','G/H':'44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
    'I/J/K':'44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L'
  };
  document.addEventListener('change', function(e) {
    var target = e.target;
    if (target.matches('hdt-richlist') || (target.tagName === 'INPUT' && target.closest('fieldset.is-style-size'))) {
      var fieldset = target.closest('fieldset.is-style-size');
      if (!fieldset) return;
      var val = target.getAttribute('selected') || target.value;
      if (!val) return;
      var labelSpan = fieldset.querySelector('[update-value]');
      if (labelSpan) labelSpan.textContent = val;
      var selectBtn = fieldset.querySelector('button.hdt-select');
      if (selectBtn) selectBtn.textContent = 'SIZE ' + val;
    }
  });

  /* ── 7. Sync variant ID to form ── */
  var formEl = document.getElementById(sectionEl.querySelector('form') ? sectionEl.querySelector('form').id : '');
  function syncVariantId() {
    var sizeInput = sectionEl.querySelector('input[is-value][name="option1"]');
    var size = sizeInput ? sizeInput.value : '';
    var color = getSelectedColor();
    if (!size || !color) return;

    var match = variantsData.find(function(v) {
      return v.options[0] === size && v.options[1] === color && v.options[2] === '1 Pack';
    });
    if (match && formEl) {
      var idInput = formEl.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
    }
  }
  sectionEl.addEventListener('change', syncVariantId);
  sectionEl.addEventListener('click', function() { setTimeout(syncVariantId, 100); });
  setTimeout(syncVariantId, 500);

  /* ── 8. Hardcoded stock map — sizes with 1 Pair qty > 0 per color ── */
  var stock = {                       
    'Beige':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Onyx':    ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Caramel': ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Ivory':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Cocoa':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C']
  };

  function filterSizes() {
    var color = getSelectedColor();
    if (!color || !stock[color]) return;
    var ok = {};
    stock[color].forEach(function(s) { ok[s] = 1; });
    var buttons = sectionEl.querySelectorAll('fieldset.is-style-size [role="option"]');
    if (!buttons.length) buttons = sectionEl.querySelectorAll('fieldset[data-index="0"] [role="option"]');
    buttons.forEach(function(btn) {
      btn.style.display = ok[btn.getAttribute('value')] ? '' : 'none';
    });
  }

  filterSizes();
  setTimeout(filterSizes, 300);
  setTimeout(filterSizes, 800);
  document.addEventListener('DOMContentLoaded', filterSizes);
  sectionEl.querySelectorAll('fieldset.is-style-color input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', function() { setTimeout(filterSizes, 50); });
  });
  sectionEl.querySelectorAll('fieldset.is-style-color label').forEach(function(label) {
    label.addEventListener('click', function() { setTimeout(filterSizes, 100); });
  });
  sectionEl.addEventListener('click', function() { setTimeout(filterSizes, 150); });
  setInterval(filterSizes, 800);

})();


/* ── Fitsize subtext + 1-line pill toggle (UK Plunge) ── */
(function() {
  var sizeFitMap = {
    '32A': '32A',
    '32B': '32B',
    '32C': '32C',
    '32D': '32D',
    '32E': '32DD',
    '32F': '32E',
    '34A': '34A',
    '34B': '34B',
    '34C': '34C',
    '34D': '34D',
    '34E': '34DD',
    '34F': '34E',
    '36A': '36A',
    '36B': '36B',
    '36C': '36C',
    '36D': '36D',
    '36E': '36DD',
    '38A': '38A',
    '38B': '38B',
    '38C': '38C',
    '38D': '38D',
    '40A': '40A',
    '40B': '40B',
    '40C': '40C'
  };

  // Copied from IL section JS: adds .is-oneline class when button content fits 1 line,
  // letting CSS bump border-radius from 12px → 100px (pill).
  function checkSelectLineCount(btn) {
    if (!btn) return;
    btn.classList.remove('is-oneline');
    var style = getComputedStyle(btn);
    var lineHeight = parseFloat(style.lineHeight) || 22;
    var paddingTop = parseFloat(style.paddingTop) || 0;
    var paddingBottom = parseFloat(style.paddingBottom) || 0;
    var contentHeight = btn.scrollHeight - paddingTop - paddingBottom;
    if (contentHeight <= lineHeight * 1.3) {
      btn.classList.add('is-oneline');
    }
  }

  // Pure function — no DOM reads.
  function renderBtnText(size) {
    if (!size) return 'Choose an option';
    var sub = sizeFitMap[size] || '';
    return (sub && sub !== size) ? (size + ' fits bra sizes: ' + sub) : ('SIZE ' + size);
  }

  function applyToBtn(btn, size) {
    if (!btn) return;
    var text = renderBtnText(size);
    if (btn.textContent !== text) btn.textContent = text;
    checkSelectLineCount(btn);
  }

  function getBtn() {
    var sec = document.querySelector('.hdt-buy-more-save-more-section');
    if (!sec) return null;
    return sec.querySelector('fieldset.is-style-size button.hdt-select');
  }

  function getCurrentSize() {
    var sec = document.querySelector('.hdt-buy-more-save-more-section');
    if (!sec) return '';
    var sizeInput = sec.querySelector('input[is-value][name="option1"]');
    return sizeInput ? (sizeInput.value || '').trim() : '';
  }

  function updateSizeBtn() {
    applyToBtn(getBtn(), getCurrentSize());
  }

  function init() {
    updateSizeBtn();

    // Synchronous click handler — fires BEFORE Shopify's native one resets the text.
    document.addEventListener('click', function(e) {
      var optBtn = e.target && e.target.closest && e.target.closest('hdt-richlist button[role="option"], hdt-richlist button[value]');
      if (!optBtn) return;
      var fieldset = optBtn.closest('fieldset.is-style-size');
      if (!fieldset) return;
      var newSize = (optBtn.getAttribute('value') || optBtn.textContent || '').trim();
      if (!newSize) return;
      var btn = fieldset.querySelector('button.hdt-select');
      applyToBtn(btn, newSize);
    }, true);

    // Synchronous change handler — reads from the change target directly (no setTimeout).
    document.addEventListener('change', function(e) {
      var t = e.target;
      if (!t || !t.matches) return;
      var fieldset = (t.closest && t.closest('fieldset.is-style-size')) || null;
      if (!fieldset) return;
      var newSize = '';
      if (t.matches('hdt-richlist')) {
        newSize = (t.getAttribute('selected') || '').trim();
      } else if (t.tagName === 'INPUT') {
        newSize = (t.value || '').trim();
      }
      if (!newSize) newSize = getCurrentSize();
      var btn = fieldset.querySelector('button.hdt-select');
      applyToBtn(btn, newSize);
    }, true);

    // MutationObserver — catches any external text reset on the button and re-applies
    // our fitsize text immediately. Eliminates remaining flicker windows.
    function watchBtn() {
      var btn = getBtn();
      if (!btn || btn._fitsizeObserved) return;
      btn._fitsizeObserved = true;
      var observing = false;
      var observer = new MutationObserver(function() {
        if (observing) return;
        var size = getCurrentSize();
        var expected = renderBtnText(size);
        if (btn.textContent !== expected) {
          observing = true;
          btn.textContent = expected;
          checkSelectLineCount(btn);
          observing = false;
        }
      });
      observer.observe(btn, { childList: true, characterData: true, subtree: true });
    }
    watchBtn();

    setTimeout(watchBtn, 200);
    setTimeout(watchBtn, 800);
    setTimeout(updateSizeBtn, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
